import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=448cde3c&scoped=true"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"
import style0 from "./Coin.vue?vue&type=style&index=0&id=448cde3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448cde3c",
  null
  
)

export default component.exports